import React from "react";
import { Login } from "@microsoft/mgt-react";
import { AppBar, Typography, Toolbar, Box } from "@mui/material";
import SailsImage from "../../images/Sails.png";
import mgtStyle from "../../style/mgtStyle.module.css";
import style from "./PageHeader.module.css";

const PageHeader = ({ title }) => {
  return (
    <AppBar position="static" color="primary">
      <Toolbar>
        <Box>
          <img
            src={SailsImage}
            style={{ height: "40px", marginRight: "1rem" }}
          />
        </Box>
        <Box className={style.title}>{title}</Box>

        <Box>
          <Login className={mgtStyle.login} />
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default PageHeader;
